<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <b-overlay :show="isBusy">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="row m-2">
              <div>
                <div>
                  <b-row>
                    <b-col sm="12" lg="2">
                      <!-- <date-picker
                        v-model="filter.StartDate"
                        format="DD.MM.YYYY"
                        style="width: 100%"
                        value-type="format"
                        :editable="true"
                        :placeholder="$t('StartDate')"
                      ></date-picker> -->
                        <custom-date-picker
                        v-model="filter.StartDate"
                        format="DD.MM.YYYY"
                        type="date"
                        :clearable="false"
                        :placeholder="$t('docdate')"
                        @keyup="BindValueStart"
                      >
                      </custom-date-picker>
                    </b-col>
                    <b-col sm="12" lg="2">
                      <!-- <date-picker
                        v-model="filter.EndDate"
                        format="DD.MM.YYYY"
                        style="width: 100%"
                        value-type="format"
                        :editable="true"
                        :placeholder="$t('EndDate')"
                      ></date-picker> -->
                        <custom-date-picker
                        v-model="filter.EndDate"
                        format="DD.MM.YYYY"
                        type="date"
                        :clearable="false"
                        :placeholder="$t('docdate')"
                        @keyup="BindValueEndDate"
                      >
                      </custom-date-picker>
                    </b-col>
                    <b-col md="2" cols="12" class="text-left">
                      <v-select
                        :options="OblastList"
                        :reduce="(item) => item.id"
                        :placeholder="$t('SelectOblast')"
                        label="name"
                        @input="OblastChange"
                        v-model="filter.OblastId"
                      ></v-select>
                    </b-col>
                    <b-col cols="12" md="2" class="text-left">
                      <v-select
                        :options="RegionList"
                        :reduce="(item) => item.id"
                        :placeholder="$t('SelectRegion')"
                        label="name"
                        @input="Refresh"
                        v-model="filter.RegionId"
                      ></v-select>
                    </b-col>
                    <!-- <b-col md="2" cols="12">
                      <v-select
                        :options="ProductCategoryList"
                        :reduce="(item) => item.id"
                        :placeholder="$t('SelectProductCategory')"
                        label="name"
                        @input="Refresh"
                        v-model="filter.ProductCategoryId"
                      ></v-select>
                    </b-col> -->
                    <b-col sm="12" lg="3" class="text-left">
                      <b-input-group>
                        <b-form-input
                          :placeholder="$t('search')"
                          v-model="filter.Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button @click="Refresh" variant="primary">
                            <i class="fas fa-search"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
            <div class="row m-2">
              <div class="table-container" style="overflow:auto; height:65vh">
                <table
                  class="table table-bordered table-responsive stikcy-header"
                >
                  <thead>
                    <tr>
                      <b-th
                        variant="info"
                        colspan="3"
                        style="text-align: center"
                      >
                        {{ $t("deals") }}
                      </b-th>
                      <b-th
                        variant="info"
                        colspan="4"
                        style="text-align: center"
                      >
                        {{ $t("bestoffer") }}
                      </b-th>
                      <b-th
                        variant="info"
                        colspan="2"
                        style="text-align: center"
                      >
                        {{ $t("provider") }}
                      </b-th>
                      <b-th
                        variant="info"
                        colspan="6"
                        style="text-align: center"
                      >
                        {{ $t("buyername") }}
                      </b-th>
                      <b-th
                        variant="info"
                        rowspan="2"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("status") }}
                      </b-th>
                    </tr>
                    <tr>
                      <b-th
                        width="6%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("№") }}
                      </b-th>
                      <b-th
                        width="6%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("ondate") }}
                      </b-th>
                      <b-th
                        width="10%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("totalcost") }}
                      </b-th>
                      <b-th
                        width="5%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("startdate") }}
                      </b-th>
                      <b-th
                        width="5%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("enddate") }}
                      </b-th>
                      <b-th
                        width="10%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("startingprice") }}
                      </b-th>
                      <b-th
                        width="5%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("productcategory") }}
                      </b-th>
                      <b-th
                        width="5%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("inn") }}
                      </b-th>
                      <b-th
                        width="10%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("name") }}
                      </b-th>
                      <b-th
                        width="5%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("inn") }}
                      </b-th>
                      <b-th
                        width="10%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("name") }}
                      </b-th>
                      <b-th
                        width="10%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("oblast") }}
                      </b-th>
                      <b-th
                        width="10%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("region") }}
                      </b-th>
                      <b-th
                        width="10%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("address") }}
                      </b-th>
                      <b-th
                        width="10%"
                        variant="info"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("buyer_acc_treasury") }}
                      </b-th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(item, i) in items"
                      style="text-align: center; vertical-align: middle"
                      :key="i"
                    >
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.best_offer_id }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.deals_mdate }}</span>
                      </td>
                      <td style="text-align: right; white-space: nowrap">
                        {{
                          $options.filters.currency(item.deals_cost, {
                            symbol: "",
                            fractionCount: 0,
                          })
                        }}
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.best_offer_start_date }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.best_offer_end_date }}</span>
                      </td>
                      <td style="text-align: right; white-space: nowrap">
                        {{
                          $options.filters.currency(
                            item.best_offer_starting_price,
                            {
                              symbol: "",
                              fractionCount: 0,
                            }
                          )
                        }}
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.best_offer_product_category }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.provider_tin }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.provider_name }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.buyer_tin }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.buyer_name }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.buyer_region }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.buyer_rayon }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.buyer_address }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.buyer_acc_treasury }}</span>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        <span>{{ item.status_name }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <br />
              </div>
            </div>
            <div>
              <b-row class="m-2">
                <b-col
                  cols="12"
                  sm="6"
                  class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-start
                "
                >
                  <span class="text-muted">
                    {{ $t("Showing") }} {{ firstNumber }} {{ $t("to") }}
                    {{ lastNumber }} {{ $t("of") }} {{ filter.totalRows }}
                    {{ $t("entries") }}
                  </span>
                </b-col>
                <b-col
                  cols="12"
                  sm="6"
                  class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-end
                "
                >
                  <b-pagination
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @input="Refresh"
                    :per-page="filter.PageLimit"
                    :total-rows="filter.totalRows"
                    v-model="filter.PageNumber"
                  >
                    <template #prev-text>
                      <i class="fas fa-angle-left"></i>
                    </template>
                    <template #next-text>
                      <i class="fas fa-angle-right"></i>
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import PageHeader from "@/components/page-header";
import ReportService from "@/services/reports/report.service";
import UzexService from "@/services/others/uzex.service";
// import HelperService from "@/services/others/helper.service";
import ProductCategoryService from "@/services/info/productcategory.service";
import CustomDatePicker from "../../../components/customDatePicker.vue"

export default {
  components: { Layout, PageHeader, Multiselect, DatePicker,CustomDatePicker },
  data() {
    return {
      title: this.$t("BudgetOtborList"),
      braedcrumb: [
        {
          text: this.$t("Reports"),
        },
        {
          text: this.$t("BudgetOtborList"),
          active: true,
        },
      ],
      isLoading: false,
      filter: {
        OblastId: 0,
        RegionId: 0,
        ProviderId: 0,
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 10,
        FinYear: 0,
        ProductCategoryId: 0,
        perPageOptions: [20, 50, 100, 200],
        totalRows: 0,
      },
      total: { totalsum: 0, totalproduct: 0 },
      items: [],
      items1: [],
      items2: [],
      OblastList: [],
      RegionList: [],
      ProductCategoryList: [],
      isBusy: false,
    };
  },
  computed: {
    firstNumber() {
      return (this.filter.PageNumber - 1) * this.filter.PageLimit + 1;
    },
    lastNumber() {
      if (this.filter.totalRows < this.filter.PageLimit) {
        return this.filter.totalRows;
      } else {
        if (
          this.filter.PageNumber * this.filter.PageLimit >
          this.filter.totalRows
        ) {
          return this.filter.totalRows;
        } else {
          return this.filter.PageNumber * this.filter.PageLimit;
        }
      }
    },
  },
  created() {
    if (!!this.$route.query.oblastid) {
      (this.filter.OblastId = this.$route.query.oblastid),
        UzexService.GetAllAuctionRegion(this.filter.OblastId).then((res) => {
          this.RegionList = res.data.result;
        });
      this.filter.RegionId = this.$route.query.regionid;
      this.filter.ProviderId = this.$route.query.providerid;
    }
    var today = new Date();
    var todaydate = new Date();
    var dd = String(todaydate.getDate()).padStart(2, "0");
    var mn = String(todaydate.getMonth() - 1).padStart(2, "0");
    var mm = String(todaydate.getMonth() + 1).padStart(2, "0");
    var yyyy = todaydate.getFullYear();
    var day =
      today.getDate() +
      "." +
      (today.getMonth() + 1) +
      "." +
      today.getFullYear();
    this.filter.StartDate = "01" + "." + "01" + "." + yyyy;
    this.filter.EndDate = dd + "." + mm + "." + yyyy;
    this.Refresh();
    UzexService.GetAllAuctionOblast().then((res) => {
      this.OblastList = res.data.result;
    });
    ProductCategoryService.GetAll(this.lang).then((res) => {
      this.ProductCategoryList = res.data;
    });
  },
  mounted() {
    var tableHeaderTop = document
      .querySelector(".stikcy-header thead")
      .getBoundingClientRect().top;
    // console.log(tableHeaderTop)
    var ths = document.querySelectorAll(".stikcy-header thead th");

    for (var i = 0; i < ths.length; i++) {
      var th = ths[i];
      th.style.top = th.getBoundingClientRect().top - tableHeaderTop + "px";
    }
  },
  methods: {

    BindValueStart(value){
      this.filter.StartDate = value
    },
    BindValueEndDate(value){
      this.filter.EndDate = value
    },
    calculate() {
      this.total = {
        totalbaseprice: 0,
        totaltotalcost: 0,
        totaleconomycost: 0,
      };
      for (var i = 0; i < this.items.length; i++) {
        this.total.totalbaseprice += 1 * this.items[i].baseprice;
        this.total.totaltotalcost += 1 * this.items[i].totalcost;
        this.total.totaleconomycost += 1 * this.items[i].economycost;
      }
    },
    showModal(item) {
      this.$bvModal.show("my-modal" + item.id);
      ReportService.GetBudgetAuctionStakan(item.lotid)
        .then((res) => {
          this.items1 = res.data.result.stakan;
          this.items2 = res.data.result.detail;
          this.isLoading = false;
          this.calculate();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    SortChange(data) {
      this.filter.SortColumn = data.sortBy;
      this.filter.OrderType = data.sortDesc ? "desc" : "asc";
      this.Refresh();
    },
    Refresh() {
      this.isBusy = true;
      ReportService.GetBudgetOtborList(
        this.filter.StartDate,
        this.filter.EndDate,
        this.filter.OblastId,
        this.filter.RegionId,
        this.filter.ProductCategoryId,
        this.filter.Search,
        this.filter.SortColumn,
        this.filter.OrderType,
        this.filter.PageNumber,
        this.filter.PageLimit
      )
        .then((res) => {
          this.items = res.data.result.rows;
          this.filter.totalRows = res.data.result.total;
          this.isBusy = false;
          this.calculate();
        })
        .catch((error) => {
          this.isBusy = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    OblastChange() {
      this.filter.RegionId = 0;
      if (!!this.filter.OblastId) {
        UzexService.GetAllAuctionRegion(this.filter.OblastId).then((res) => {
          this.RegionList = res.data.result;
        });
        this.Refresh();
      }
    },
  },
};
</script>

<style>
.text-right {
  text-align: right;
}
</style>
